import { render, staticRenderFns } from "./AddDomainWorkspace.vue?vue&type=template&id=f3199cda"
import script from "./AddDomainWorkspace.vue?vue&type=script&lang=js"
export * from "./AddDomainWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports